module.exports = __webpack_public_path__ + "img/error.855d483e.png";